<template lang="pug">
.nutrition-images-swiper
  .master
    .helper
      i.bx.bx-zoom-in
    swiper.swiper(
      ref="mySwiper"
      :options="swiperOption"
      :auto-destroy="false")
      swiper-slide(
        v-for="i, k in nutritions"
        :key="k")
        .contain(
          :style="{ backgroundImage: `url(${i.large})`, transform: `rotate(${i.attachment_rotate}deg)` }"
          @click="handleZoom(k)")
      .swiper-pagination(slot="pagination")

</template>

<script>
import ImagesSwiper from '~/components/modals/ImagesSwiper'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

export default {
  components: {
    Swiper,
    SwiperSlide
  },

  props: {
    nutritions: {
      type: Array,
      default: () => ([])
    }
  },

  data () {
    return {
        swiperOption: {
          spaceBetween: 30,
          centeredSlides: true,
          autoplay: {
            delay: 50000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        }
      }
  },

  methods: {
    handleZoom (index) {
      this.$dialogs.open({
        parent: this,
        component: ImagesSwiper,
        props: {
          images: this.nutritions.map(e => ({ ...e, url: e.large })),
          initialIndex: index
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.nutrition-images-swiper {
  padding-top: 15px;
  .master {
    position: relative;
    font-size: 0;
    position: relative;
    border-radius: $--radius;
    overflow: hidden;
    &:hover {
      .helper {
        background: $--color-primary;
      }
    }
    .helper {
      z-index: 2;
      pointer-events: none;
      position: absolute;
      bottom: 16px;
      right: 16px;
      width: 44px;
      height: 44px;
      background: rgba(black, .2);
      backdrop-filter: blur(16px);
      border-radius: 1000px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      color: white;
      transition: background .2s ease-in-out;
    }
    .swiper-slide {
      .contain {
        background-color: white;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        width: 100%;
        height: 0;
        padding-top: 100%;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
